<template>
  <v-app>
    <SideBar v-if="['Login'].indexOf($route.name) < 0"></SideBar>
    <Header v-if="['Login'].indexOf($route.name) < 0"></Header>
        <v-content>
          <router-view style="margin-bottom:50px"></router-view>
          <Footer v-if="['Login'].indexOf($route.name) < 0"></Footer>
        </v-content>
  </v-app>
</template>

<script>
import Header from './components/Header'
import SideBar from './components/SideBar'
import Footer from './components/Footer'
export default {
  name: 'App',
  components: {
    Header,
    Footer,
    SideBar

  }
}
</script>

<style>
  .v-application a{
    text-decoration: none;
  }
</style>

